import Glide from "@glidejs/glide";
import Heading from "components/Heading/Heading";
import React, { FC, useId } from "react";
import { useEffect } from "react";
import clientSayMain from "images/clientSayMain.png";
import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import quotationImg2 from "images/quotation2.png";
import { StarIcon } from "@heroicons/react/24/solid";
import "./clientSay.module.css";

export interface SectionClientSayProps {
  className?: string;
}

const DEMO_DATA = [
  {
    id: 1,
    clientName: "Vennam Bhagavan Reddy",
    content:
      "I am working with Agrotracdigital for the past four years I am getting mechanised Paddy Transplating, Track Harvester and Sprayer services.ECS team is professional, transparent, and commited for customer statisfaction.",
  },
  {
    id: 2,
    clientName: "Potharaju Mahendar",
    content:
      "I have attached by  Kobota Track Harvester with Escorts Crop Solutions, My earning have increased, I get my payment in full on time. I will add more machines with them in coming season. ",
  },
  {
    id: 3,
    clientName: "Kamidi Sripatireddy",
    content:
      "I am a franchisee partner to Agrotracdigital, I am earning a decent income with Farming services as well as Machinery Sales. Now I am inventing my money in adding my own fleet.",
  },
];

const SectionClientSay: FC<SectionClientSayProps> = ({ className = "" }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 499, min: 0 },
      items: 1,
      partialVisibilityGutter: 30,
    },
  };
  //
  //
  return (
    <Carousel
      rewindWithAnimation={true}
      partialVisible={true}
      responsive={responsive}
      swipeable={true}
      showDots={false}
      autoPlay={true}
      ssr={true}
      infinite={true}
      autoPlaySpeed={4000}
      minimumTouchDrag={20}
      customTransition="all .6s ease-out"
      transitionDuration={1000}
      containerClass="carousel-container"
      removeArrowOnDeviceType={["tablet", "mobile"]}
      dotListClass="custom-dot-list-style"
      itemClass="carousel-item-padding-20-px"
      // partialVisibilityGutter={35}
      rewind={true}
      pauseOnHover={false}
    >
      <div className="container">
        <div
          className={`nc-SectionClientSay relative flow-root  ${className} `}
          data-nc-id="SectionClientSay"
        >
          <div className="relative md:mb-8 max-w-2xl mx-auto bgcolor text-sm">
            {/* {renderBg()} */}

            <img className="mx-auto hidden" src={clientSayMain} alt="" />
            <div className={`mt-12 lg:mt-6 relative `}>
              <div className="glide__track " data-glide-el="track">
                <ul className="glide__slides ">
                  {DEMO_DATA.map((item) => (
                    <li
                      key={item.id}
                      className="glide__slide flex flex-col items-center text-center"
                    >
                      <span className="w-[80px] h-[80px]">
                        <img
                          src="images/user.png"
                          className="border border-[#D9D9D9] rounded-full"
                        />
                      </span>
                      <span className="block mt-3 text-md font-semibold text-[#F17400]">
                        {item.clientName}
                      </span>
                      <div className="flex items-center space-x-0.5 my-3.5 text-yellow-500">
                        <StarIcon className="w-6 h-6" />
                        <StarIcon className="w-6 h-6" />
                        <StarIcon className="w-6 h-6" />
                        <StarIcon className="w-6 h-6" />
                      </div>
                      <span className="block text-xs md:text-md text-[#525252] font-roboto">
                        {item.content}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className="mt-6 glide__bullets flex items-center justify-center"
                data-glide-el="controls[nav]"
              >
                {DEMO_DATA.map((item, index) => (
                  <button
                    key={item.id}
                    className="glide__bullet w-2 h-2 rounded-full bg-neutral-300 mx-1 focus:outline-none"
                    data-glide-dir={`=${index}`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Carousel>
  );
};

export default SectionClientSay;
